import { Flex } from "@mantine/core";
import { useMemo } from "react";
import { withErrorBoundary } from "react-error-boundary";

import { useLogger } from "@/sdk/logging/LoggerProvider";
import { createFallbackRender } from "@/shared-utils";
import { PlatformTimeline } from "@/timeline";

export function AssistTab() {
    const logger = useLogger({ module: "AssistTab" });

    const PlatformTimelineHandled = useMemo(
        () =>
            withErrorBoundary(PlatformTimeline, {
                fallbackRender: createFallbackRender(logger),
            }),
        [logger],
    );

    return (
        <Flex pos="absolute" inset={0} direction="column">
            <PlatformTimelineHandled />
        </Flex>
    );
}
